import React from 'react'

/**
 * PageLoader Component
 * Provides a consistent loading experience while lazy-loaded pages are being fetched
 * Used as Suspense fallback for route-based code splitting
 */
export const PageLoader: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="text-center space-y-4">
        {/* Animated spinner */}
        <div className="relative w-16 h-16 mx-auto">
          <div className="absolute inset-0 border-4 border-blue-200 dark:border-blue-800 rounded-full"></div>
          <div className="absolute inset-0 border-4 border-transparent border-t-blue-500 dark:border-t-blue-400 rounded-full animate-spin"></div>
        </div>

        {/* Loading text */}
        <p className="text-gray-600 dark:text-gray-400 text-sm font-medium">
          Loading...
        </p>
      </div>
    </div>
  )
}

/**
 * ComponentLoader
 * Smaller loader for component-level suspense boundaries
 */
export const ComponentLoader: React.FC<{ className?: string }> = ({ className = '' }) => {
  return (
    <div className={`flex items-center justify-center py-12 ${className}`}>
      <div className="relative w-8 h-8">
        <div className="absolute inset-0 border-4 border-blue-200 dark:border-blue-800 rounded-full"></div>
        <div className="absolute inset-0 border-4 border-transparent border-t-blue-500 dark:border-t-blue-400 rounded-full animate-spin"></div>
      </div>
    </div>
  )
}

export default PageLoader
